import {
    removeSeriesFromCalendar,
    removeFromCalendar,
} from './getRemoveFromCalendarCaption.locstring.json';
import loc from 'owa-localize';

export default function getRemoveFromCalendarCaption(
    isRecurring: boolean,
    isSeriesCancelled: boolean
): string {
    return isRecurring && isSeriesCancelled
        ? loc(removeSeriesFromCalendar)
        : loc(removeFromCalendar);
}
